import React from 'react'
import { FaDownload } from 'react-icons/fa'
import { IconTooltip as Tooltip } from '../Tooltip'

const ChartDownloadButton = ({ name, onDownload, disabled, inHeader = true }) => {
    const handleClick = () => {
        if (disabled) return
        onDownload()
    }

    return (
        <div
            className={`${inHeader ? 'panelHeaderIconDiv' : 'clickable'}`}
            data-tooltip-content="Download Data"
            data-tooltip-id={`${name}-download`}
            onClick={handleClick}
            style={disabled ? { opacity: 0.4, cursor: 'not-allowed' } : { cursor: 'pointer' }}
        >
            <FaDownload />
            <Tooltip id={`${name}-download`} />
        </div>
    )
}

export default ChartDownloadButton
